import { render, staticRenderFns } from "./FormControlModulecomponentsThumbnailColumn.vue?vue&type=template&id=5d196c82&scoped=true"
import script from "./FormControlModulecomponentsThumbnailColumn.vue?vue&type=script&setup=true&lang=js"
export * from "./FormControlModulecomponentsThumbnailColumn.vue?vue&type=script&setup=true&lang=js"
import style0 from "./FormControlModulecomponentsThumbnailColumn.vue?vue&type=style&index=0&id=5d196c82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d196c82",
  null
  
)

export default component.exports